import { model, attr } from 'services/model'
import * as yup from 'yup'

const validationSchema = yup.object().shape({
  name: yup
    .string()
    .typeError('Field name has wrong type')
    .default(null)
    .nullable(),
  value: yup
    .string()
    .typeError('Field value has wrong type')
    .default(null)
    .nullable(),
  icon: yup
    .string()
    .typeError('Field icon has wrong type')
    .default(null)
    .nullable()
})

const EditorStatus = model(
  'editorStatus',
  {
    name: attr('string'),
    value: attr('string'),
    icon: attr('string')
  },
  validationSchema
)

export default EditorStatus
